module.exports = __webpack_public_path__ + "static/media/picked_bank_cards.1bba98b8.svg";